import React, { useState,useEffect } from 'react';

const DineInSwitcher = ({ setMultiSelect }) => {
    const [selected, setSelected] = useState('single');
    useEffect(() => {
        setMultiSelect(false)
    }, []);
    const onchange = (selected) => {
        if (selected == 'multi') {
            setSelected('multi')
            setMultiSelect(true)
        } else {
            setSelected('single')
            setMultiSelect(false)
        }
    }
    
    return (
        <div className="dinein-switcher dine-in-switcher ">
            <div
                className={`switch-option ${selected === 'multi' ? 'active' : ''}`}
                onClick={() => onchange('multi')}
            >
                Multi Select
            </div>
            <div
                className={`switch-option ${selected === 'single' ? 'active' : ''}`}
                onClick={() => onchange('single')}
            >
                Select One
            </div>
            <div className={`switch-slider ${selected === 'single' ? 'right' : 'left'}`} />
        </div>
    );
};

export default DineInSwitcher;
